import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { AppErrorBoundary } from './components/common/AppErrorBoundary/AppErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { installAuthInterceptor } from './services/http/client';
import { initSentry } from './services/sentry';

initSentry();

// Covers the services that call the shared default instance directly rather
// than creating their own: auth, common, core, eligibility, and referral.
// Instances made with `axios.create` do not inherit these interceptors, which is
// why every created client goes through `createApiClient` instead.
// Safe to install globally: the monitor ignores any request whose URL does not
// resolve to one of our own API hosts.
installAuthInterceptor(axios);

ReactDOM.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
